// Stable request ids for voice delegations. The server accepts
// /^[a-zA-Z0-9_.:-]{1,160}$/. Opaque delegation ids are passed back to Live
// unchanged; for OUR request id we use the delegation id verbatim when it fits
// the server's alphabet, otherwise a 64-bit FNV-1a hash of it. Never truncate:
// two long ids that share a prefix must not collide.

const SAFE = /^[a-zA-Z0-9_.:-]{1,150}$/;

function fnv1a64Hex(str) {
  // Two independent 32-bit FNV-1a lanes over UTF-16 code units → 64 bits.
  let h1 = 0x811c9dc5, h2 = 0x01000193 ^ 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);
    h1 ^= c; h1 = Math.imul(h1, 0x01000193) >>> 0;
    h2 ^= (c * 31 + i) & 0xffff; h2 = Math.imul(h2, 0x01000193) >>> 0;
  }
  return h1.toString(16).padStart(8, '0') + h2.toString(16).padStart(8, '0');
}

export function requestIdForDelegation(delegationId) {
  const id = delegationId == null ? '' : String(delegationId);
  if (!id) return null;
  if (SAFE.test(id)) return `voice-${id}`;
  return `voice-h-${fnv1a64Hex(id)}`;
}

export { fnv1a64Hex };
